import React from 'react';

import {Flex} from '../components/styled/Flex';
import {LMediaQuery, MMediaQuery, SMediaQuery, XLMediaQuery, XSMediaQuery} from "../components/mediaquery";
import {Text} from "../components/styled/Text";

type ReactNode = React.ReactNode | React.ReactNode[];
type Direction = 'row' | 'column';

interface HorizontalLayoutProps {
    children: ReactNode;
    style?: React.CSSProperties;
    className?: string;
}
export const HorizontalLayout: React.FC<HorizontalLayoutProps> = (props) => {

    const childrenWrapper = (children: ReactNode, direction: Direction):ReactNode  => {
        if (direction === 'column') {
            if (Array.isArray(children)) {
                return children.map((child, i) =>
                    <Text key={i} marginTop={'5px'} marginBottom={'5px'} width={'100%'}>{child}</Text>
                )
            } else {
                return <Text marginTop={'5px'} marginBottom={'5px'}>{children}</Text>
            }
        }

        return children;
    }

    const renderLayout = (direction: Direction, align: string, justity: string, wrap: string) => {

        return (
            <Flex
                direction={direction}
                align={align}
                justify={justity}
                wrap={wrap}
                className={props.className}
                style={(props.style !== undefined ? props.style : {width: '100%'})}

            >
                {childrenWrapper(props.children, direction)}
            </Flex>
        )
    };

    return (

        <>
        <XLMediaQuery>
            {renderLayout('row', 'center', 'space-between','flex-wrap')}
        </XLMediaQuery>
        <LMediaQuery>
            {renderLayout('row', 'center', 'space-between','flex-wrap')}
        </LMediaQuery>
        <MMediaQuery>
            {renderLayout('column', 'flex-start', 'space-around','flex-wrap')}
        </MMediaQuery>
        <XSMediaQuery>
            {renderLayout('column', 'flex-start', 'space-around','flex-wrap')}
        </XSMediaQuery>
        <SMediaQuery>
            {renderLayout('column', 'flex-start', 'space-around','flex-wrap')}
        </SMediaQuery>
        </>

    )
}